<template>
  <div class="dialog-qr-login">
    <iframe sandbox="allow-scripts allow-same-origin allow-top-navigation allow-popups"
            scrolling="no"
            width="300"
            height="300"
            frameBorder="0"
            allowTransparency="true"
            allow="local-network-access"
            :src="setSrc"></iframe>
  </div>
</template>

<script>
import base64 from '@/request/base64';
export default {
  name: 'DialogQRAuth',
  data () {
    return {
      //应用唯一标识，在微信开放平台提交应用审核通过后获得
      appid: 'wx59ae7100c990f202',
      //应用授权作用域，拥有多个作用域用逗号（,）分隔，网页应用目前仅填写snsapi_login即可
      scope: 'snsapi_login',
      //重定向地址，需要进行UrlEncode
      redirect_uri: encodeURIComponent('https://datainside.com.cn/auth/dialogqrcallback'),
      //用于保持请求和回调的状态，授权请求后原样带回给第三方。该参数可用于防止csrf攻击（跨站请求伪造攻击），建议第三方带上该参数，可设置为简单的随机数加session进行校验
      state: '',
      //提供"black"、"white"可选，默认为黑色文字描述。详见文档底部FAQ
      theme: 'black',
      // 自定义样式链接，第三方可根据实际需求覆盖默认样式。详见文档底部FAQ
      href: 'data:text/css;base64,',
      // true：手机点击确认登录后可以在 iframe 内跳转到 redirect_uri，false：手机点击确认登录后可以在 top window 跳转到 redirect_uri。默认为 false。
      self_redirect: 'true',
      // sdk的扩展字符串，但是在这里就默认了jssdk，暂时不建议修改
      login_type: 'jssdk',
    }
  },
  computed: {
    setSrc () {
      var _url = 'https://open.weixin.qq.com/connect/qrconnect?appid=' + this.appid
        + '&scope=' + this.scope
        + '&redirect_uri=' + this.redirect_uri
        + '&state=' + this.state
        + '&login_type=' + this.login_type
        + '&style=' + this.theme
        + '&self_redirect=' + this.self_redirect
        + '&href=' + this.href + base64.encode('.impowerBox .qrcode {width: 220px;}.impowerBox .title {display: none;}.impowerBox .info {width: 300px;}.impowerBox .status {text-align:center;}.impowerBox .status_txt {text-align:left;}');
      return _url;
    },
  }
}
</script>

<style lang="scss">
.dialog-qr-login {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #ffffff;
  justify-content: center;
}
</style>
